var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNewspaperClipping = function SvgIconNewspaperClipping(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.875 9.125a1 1 0 1 0 0 2h3.375a1 1 0 1 0 0-2zM12.875 13.875a1 1 0 0 1 1-1h3.375a1 1 0 1 1 0 2h-3.375a1 1 0 0 1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.75 8a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h3.75a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zm1 6v-4H9.5v4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 3.5A1.75 1.75 0 0 0 2 5.25v15a1 1 0 0 0 1.447.894L6 19.868l2.553 1.276a1 1 0 0 0 .894 0L12 19.868l2.553 1.276a1 1 0 0 0 .894 0L18 19.868l2.553 1.276A1 1 0 0 0 22 20.25v-15a1.75 1.75 0 0 0-1.75-1.75zM4 18.632V5.5h16v13.132l-1.553-.776a1 1 0 0 0-.894 0L15 19.132l-2.553-1.276a1 1 0 0 0-.894 0L9 19.132l-2.553-1.276a1 1 0 0 0-.894 0z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconNewspaperClipping;